import { Api } from "api";

export const getCodes = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/codeits/?hash_pw=${hash}`);
  return res.data;
};

export const addCode = async (codeIt: string) => {
  const hash = localStorage.getItem("hash");
  const url = `/codeit/?hash_pw=${hash}&code_it=${codeIt}`;
  const res = await Api.post(url);
  return res.data;
};

export const updateCode = async (
  codeItId: number,
  new_code_it: string,
  isChanging: boolean,
  new_status?: boolean
) => {
  const hash = localStorage.getItem("hash");
  const name = new_code_it !== undefined ? `&new_code_it=${new_code_it}` : "";
  const status = new_status !== undefined ? `&status=${new_status}` : "";
  const change = isChanging !== undefined ? `&change_existing_codeit=${isChanging}` : "";
  const url = `/codeit/?hash_pw=${hash}&code_it_id=${codeItId}${name}${status}${change}`;
  const res = await Api.put(url);
  return res.data;
};
